import { render, staticRenderFns } from "./CajaHeader.vue?vue&type=template&id=1c95bddd&scoped=true&"
import script from "./CajaHeader.vue?vue&type=script&lang=js&"
export * from "./CajaHeader.vue?vue&type=script&lang=js&"
import style0 from "./CajaHeader.vue?vue&type=style&index=0&id=1c95bddd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c95bddd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
